var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGraphen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5186 18.4203C49.9259 13.7499 59.5884 11.0653 69.8724 11V32.1744C68.9717 32.3319 68.1826 32.8141 67.6303 33.4959L41.5186 18.4203Z",
    fill: "#86D5D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.852 19.4946C109.293 24.5924 116.36 31.7361 121.366 40.2388L103.279 50.6818C102.676 49.9858 101.819 49.5163 100.852 49.4179L100.852 19.4946Z",
    fill: "#A2DADB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9832 37.1628L97.5765 50.7844C98.1291 50.098 98.921 49.6124 99.8255 49.4542L99.8255 19.271L73.8779 34.2519C74.1034 34.7309 74.2294 35.266 74.2294 35.8306C74.2294 36.3001 74.1422 36.7493 73.9832 37.1628Z",
    fill: "#86D5D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8984 11.0021C81.1399 11.1104 90.7585 13.8166 99.1265 18.4928L73.318 33.3933C72.7157 32.702 71.8615 32.2359 70.8984 32.1379V11.0021Z",
    fill: "#86D5D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1033 34.373L40.9463 19.2712L40.9463 49.418C41.9133 49.5164 42.7706 49.986 43.3733 50.682L67.0066 37.0373C66.8767 36.659 66.8061 36.2532 66.8061 35.8308C66.8061 35.3133 66.912 34.8206 67.1033 34.373Z",
    fill: "#57C4CB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9236 19.3411C31.4054 24.4266 24.2705 31.5888 19.2178 40.1287L37.6745 50.7847C38.2271 50.0983 39.019 49.6127 39.9236 49.4545L39.9236 19.3411Z",
    fill: "#57C4CB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7019 41.0144C13.9327 49.4028 11.1518 59.0691 11 69.3721L37.0575 54.3279C36.9252 53.9466 36.8533 53.5371 36.8533 53.1107C36.8533 52.5972 36.9576 52.108 37.1462 51.6632L18.7019 41.0144Z",
    fill: "#57C4CB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9209 84.0145V56.7672C38.9323 56.5943 38.0783 56.0303 37.5241 55.2406L11.5049 70.2628L37.6578 85.3622C38.211 84.6665 39.0087 84.174 39.9209 84.0145Z",
    fill: "#57C4CB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 71.1533C11.1518 81.4564 13.9327 91.1226 18.7019 99.5111L37.0649 88.9091C36.9279 88.5218 36.8533 88.105 36.8533 87.6707C36.8533 87.1651 36.9544 86.6831 37.1375 86.2438L11 71.1533Z",
    fill: "#3299A0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2178 100.397C24.2705 108.937 31.4054 116.099 39.9236 121.184L39.9236 91.3269C38.9426 91.1553 38.0941 90.5987 37.5397 89.8185L19.2178 100.397Z",
    fill: "#3299A0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8724 129.526C59.5884 129.46 49.9259 126.776 41.5186 122.105L67.4949 107.108C68.0495 107.883 68.8952 108.436 69.8724 108.607V129.526Z",
    fill: "#3299A0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.086 103.534L43.5152 89.9254C42.9092 90.7168 41.9919 91.2571 40.9463 91.3635L40.9463 121.254L67.0215 106.2C66.8821 105.809 66.8061 105.389 66.8061 104.951C66.8061 104.449 66.9057 103.971 67.086 103.534Z",
    fill: "#3299A0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1265 122.033C90.7585 126.709 81.1399 129.415 70.8984 129.523V108.643C71.9402 108.537 72.8545 108.001 73.4605 107.214L99.1265 122.033Z",
    fill: "#037C84"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4425 89.8187L73.8975 103.412C74.1112 103.881 74.2302 104.402 74.2302 104.951C74.2302 105.436 74.1371 105.9 73.9676 106.325L99.8264 121.254V91.3271C98.8454 91.1556 97.997 90.5989 97.4425 89.8187Z",
    fill: "#037C84"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.366 100.287C116.36 108.789 109.293 115.933 100.852 121.031V91.3635C101.897 91.2571 102.814 90.7168 103.42 89.9254L121.366 100.287Z",
    fill: "#037C84"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.514 71.3024C129.339 81.504 126.586 91.0775 121.878 99.3995L103.925 89.0342C104.091 88.6121 104.183 88.152 104.183 87.6706C104.183 87.1179 104.062 86.5934 103.846 86.1221L129.514 71.3024Z",
    fill: "#037C84"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.852 70.2628V83.978C101.826 84.0772 102.69 84.5537 103.293 85.2591L129.268 70.2628L100.852 70.2628Z",
    fill: "#037C84"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4102 70.2629L97.5631 85.3623C98.1163 84.6667 98.9139 84.1741 99.8261 84.0146V70.2629L71.4102 70.2629Z",
    fill: "#037C84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGraphen);
export default __webpack_public_path__ + "static/media/Logo_graphen.d7c9c23f13ab79fc4fc6600b197985f0.svg";
export { ForwardRef as ReactComponent };